import IfGlobalOrg from '@/components/organizations/IfGlobalOrg'
import { OrganizationContextNotice } from '@/components/patterns/info-notice'
import { createFileRoute, notFound } from '@tanstack/react-router'

import AlbumEditor from '@/components/gallery/AlbumEditor'

export const Route = createFileRoute('/_authenticated/$orgId/gallery/album/create')({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    if (!context.ability?.can('list', 'albums')) throw notFound()

    if (+params.orgId === +import.meta.env.VITE_TUKIOS_FLOWERS_ORG_ID) {
      return { isReadOnly: true }
    }

    return { isReadOnly: !context.ability.can('edit', 'albums') }
  },
})

function RouteComponent() {
  return (
    <IfGlobalOrg
      show={false}
      fallback={
        <OrganizationContextNotice className="mb-4">
          Gallery is organization-specific.
        </OrganizationContextNotice>
      }
    >
      <AlbumEditor album={null} />
    </IfGlobalOrg>
  )
}
